import Vue from "vue";
import VueRouter from "vue-router";
import { authGuard, getInstance } from "../auth";
// import Agenda from "../views/Agenda.vue";
// import Admin from "../views/Admin.vue";
// import MyProfile from "../views/MyProfile.vue";
// import ActivityLogs from "../views/ActivityLogs.vue";
// import Documents from "@/views/Documents.vue";
// import MeetingView from "@/views/MeetingView";
// import Calendar from "@/views/Calendar";
// import Download from "@/views/Download";
// import ProfilePage from "../components/people/ProfilePage.vue";
// import ProductUpdate from "@/views/ProductUpdate";
// import UserManual from "@/views/UserManual";
// import Forbidden from "@/views/Forbidden";
import authority from "../plugins/authority";
import store from "../store";
// import MeetingTimerView from "@/views/MeetingTimerView";
// import PageNotFound from "@/views/PageNotFound";
// import Poll from "@/views/Poll";
// import PollSurvey from "@/components/poll/PollSurvey";
// import CreatePoll from "@/components/poll/CreatePoll";
// import CreateSurvey from "@/components/poll/CreateSurvey";
// import SurveyDetails from "@/components/poll/SurveyDetails";
// import LicensePolicy from "@/views/LicensePolicy";
// import StatisticsAnalysis from "@/views/Statistics&Analysis.vue";
// import AttendanceAnalysis from "@/components/statistics/AttendanceAnalysis.vue";
// import TimeAllocation from "@/components/statistics/TimeAllocation.vue";
// import SessionExpired from "@/views/SessionExpired";
// import { async } from "q";
// import Task from "@/views/Task.vue";
// import MeetingTimer from '@/views/MeetingTimer'

Vue.use(VueRouter);

const routes = [
  {
    path: "*",
    //component: PageNotFound,
    component: () =>
      import(/* webpackChunkName: "pagenotfound" */ "@/views/PageNotFound"),
    meta: {
      authorizationKey: "Allowed",
      middleware: [authority],
    },
  },
  {
    path: "/dashboard",
    name: "dashboard",
    component: () =>
      import(/* webpackChunkName: "home" */ "../views/Home.vue"),
    beforeEnter: authGuard,
    meta: {
      authorizationKey: "ViewDashboard",
      middleware: [authority],
    },
  },
  {
    path: "/",
    name: "LandingPage",
    component: () =>
      import(/* webpackChunkName: "landingpage" */ "../views/LandingPage.vue"),
    beforeEnter: authGuard,
    meta: {
      authorizationKey: "Allowed",
      middleware: [authority],
    },
  },
  {
    path: "/agenda",
    name: "Agenda",
    //component: Agenda,
    component: () =>
      import(/* webpackChunkName: "agenda" */ "../views/Agenda.vue"),
    beforeEnter: authGuard,
    meta: {
      authorizationKey: "ViewAgenda",
      middleware: [authority],
    },
  },
  {
    path: "/calendar",
    name: "Calendar",
    beforeEnter: authGuard,
    // component: Calendar,
    component: () =>
      import(/* webpackChunkName: "calendar" */ "@/views/Calendar"),
    meta: {
      authorizationKey: "ViewCalendar",
      middleware: [authority],
    },
  },

  {
    path: "/meeting/:id/:origin/tenant/:tenantId",
    name: "Meeting",
    //component: MeetingView,
    component: () =>
      import(/* webpackChunkName: "meeting" */ "@/views/MeetingView"),
    beforeEnter: authGuard,
    meta: {
      authorizationKey: "Allowed",
      middleware: [authority],
    },
  },
  {
    path: '/meetingTimer/:id',
    name: 'MeetingTimer',
    //component: MeetingTimerView,
    component: () =>
      import(/* webpackChunkName: "meetingtimer" */ "@/views/MeetingTimer"),
    beforeEnter: authGuard,
    meta: {
      authorizationKey: "Allowed",
      middleware: [authority],
    },
  },
  {
    path: "/people",
    name: "People",
    beforeEnter: authGuard,
    //component: PeopleInformation,
    component: () =>
      import(/* webpackChunkName: "peopleinformation" */ "../components/people/PeopleInformation.vue"),
    meta: {
      authorizationKey: "ViewPeople",
      middleware: [authority],
    },
  },
  {
    path: "/people/:id/tenant/:tenantId/:origin",
    name: "Profile",
    beforeEnter: authGuard,
    //component: ProfilePage,
    component: () =>
      import(/* webpackChunkName: "profilepage" */ "../components/people/ProfilePage.vue"),
    meta: {
      authorizationKey: "ViewPeople",
      middleware: [authority],
    },
  },
  {
    path: "/admin",
    name: "Admin",
    beforeEnter: authGuard,
    //component: Admin,
    component: () =>
      import(/* webpackChunkName: "admin" */ "../views/Admin.vue"),
    meta: {
      authorizationKey: "ViewAdmin",
      middleware: [authority],
    },
  },
  {
    path: "/documents",
    name: "Documents",
    beforeEnter: authGuard,
    //component: Documents,
    component: () =>
      import(/* webpackChunkName: "admin" */ "../views/Documents.vue"),
    meta: {
      authorizationKey: "ViewDocuments",
      middleware: [authority],
    },
  },
  {
    path: "/activitylogs",
    name: "ActivityLogs",
    beforeEnter: authGuard,
    //component: ActivityLogs,
    component: () =>
      import(/* webpackChunkName: "admin" */ "../views/ActivityLogs.vue"),
    meta: {
      authorizationKey: "ViewActivityLogs",
      middleware: [authority],
    },
  },
  {
    path: "/communications",
    name: "Communications",
    beforeEnter: authGuard,
    component: () =>
      import(/* webpackChunkName: "home" */ "../views/Home.vue"),
    meta: {
      authorizationKey: "ViewCommunications",
      middleware: [authority],
    },
  },
  {
    path: "/survey",
    name: "Survey",
    beforeEnter: authGuard,
    //component: PollSurvey,
    component: () =>
      import(/* webpackChunkName: "survey" */ "@/components/poll/PollSurvey"),
    meta: {
      authorizationKey: "ViewSurveyPolls",
      middleware: [authority],
    },
  },
  {
    path: "/survey/add/:type/:origin/:surveyid",
    name: "CopySurvey",
    beforeEnter: authGuard,
    //component: CreateSurvey,
    component: () =>
      import(/* webpackChunkName: "createsurvey" */ "@/components/poll/CreateSurvey"),
    meta: {
      authorizationKey: "ViewSurveyPolls",
      middleware: [authority],
    },
  },
  {
    path: "/poll/add/:type/:origin/:pollid",
    name: "CopyPoll",
    beforeEnter: authGuard,
    //component: CreatePoll,
    component: () =>
      import(/* webpackChunkName: "createpoll" */ "@/components/poll/CreatePoll"),
    meta: {
      authorizationKey: "ViewSurveyPolls",
      middleware: [authority],
    },
  },
  {
    path: "/survey/add/:id/:origin",
    name: "SurveyCreate",
    beforeEnter: authGuard,
    //component: CreateSurvey,
    component: () =>
      import(/* webpackChunkName: "createsurvey" */ "@/components/poll/CreateSurvey"),
    meta: {
      authorizationKey: "ViewSurveyPolls",
      middleware: [authority],
    },
  },
  {
    path: "/poll/add/:id/:origin",
    name: "PollCreate",
    beforeEnter: authGuard,
    //component: CreatePoll,
    component: () =>
      import(/* webpackChunkName: "createpoll" */ "@/components/poll/CreatePoll"),
    meta: {
      authorizationKey: "ViewSurveyPolls",
      middleware: [authority],
    },
  },
  {
    path: "/survey/:id/tenant/:tenantId/:origin",
    name: "SurveyDetails",
    beforeEnter: authGuard,
    //component: SurveyDetails,
    component: () =>
      import(/* webpackChunkName: "createpoll" */ "@/components/poll/SurveyDetails"),
    meta: {
      authorizationKey: "ViewSurveyPolls",
      middleware: [authority],
    },
  },
  {
    path: "/myprofile",
    name: "MyProfile",
    beforeEnter: authGuard,
    //component: MyProfile,
    component: () =>
      import(/* webpackChunkName: "myprofile" */ "../views/MyProfile.vue"),
    meta: {
      authorizationKey: "MyProfile",
      middleware: [authority],
    },
  },
  {
    path: "/search",
    name: "GlobalSearch",
    beforeEnter: authGuard,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "globalsearch" */ "../views/GlobalSearch.vue"),
    meta: {
      authorizationKey: "Allowed",
      middleware: [authority],
    },
  },
  {
    path: "/productupdate",
    name: "ProductUpdate",
    beforeEnter: authGuard,
    //component: ProductUpdate,
    component: () =>
      import(/* webpackChunkName: "productupdate" */ "@/views/ProductUpdate"),
    meta: {
      authorizationKey: "Allowed",
      middleware: [authority],
    },
  },
  {
    path: "/usermanual",
    name: "UserManual",
    beforeEnter: authGuard,
    //component: UserManual,
    component: () =>
      import(/* webpackChunkName: "usermanual" */ "@/views/UserManual"),
    meta: {
      authorizationKey: "Allowed",
      middleware: [authority],
    },
  },
  {
    path: "/licensepolicy",
    name: "LicensePolicy",
    beforeEnter: authGuard,
    //component: LicensePolicy,
    component: () =>
      import(/* webpackChunkName: "licensepolicy" */ "@/views/LicensePolicy"),
    meta: {
      authorizationKey: "Allowed",
      middleware: [authority],
    },
  },
  {
    path: "/forbidden",
    name: "Forbidden",
    //component: Forbidden,
    component: () =>
      import(/* webpackChunkName: "forbidden" */ "@/views/Forbidden"),
    meta: {
      authorizationKey: "Allowed",
      middleware: [authority],
    },
  },
  {
    path: "/sessionexpired",
    name: "SessionExpired",
    //component: SessionExpired,
    component: () =>
      import(/* webpackChunkName: "sessionexpired" */ "@/views/SessionExpired"),
    meta: {
      authorizationKey: "Allowed",
      middleware: [authority],
    },
  },
  {
    path: "/login",
    name: "Login",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
    meta: {
      authorizationKey: "Allowed",
      middleware: [authority],
    },
  },
  {
    path: "/download/:id/tenant/:tenantId",
    name: "Download",
    beforeEnter: authGuard,
    //component: Download,
    component: () =>
      import(/* webpackChunkName: "download" */ "@/views/Download"),
    meta: {
      authorizationKey: "DownloadDocument",
      middleware: [authority],
    },
  },
  {
    path: "/components",
    name: "Components",
    beforeEnter: authGuard,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "components" */ "../views/Components.vue"),
    meta: {
      authorizationKey: "Allowed",
      middleware: [authority],
    },
  },
  {
    path: "/statistics&analysis",
    name: "StatisticsAnalysis",
    beforeEnter: authGuard,
    //component: StatisticsAnalysis,
    component: () =>
      import(/* webpackChunkName: "statisticsanalysis" */ "@/views/Statistics&Analysis.vue"),
    meta: {
      authorizationKey: "ViewMeetingStatistics",
      middleware: [authority],
    },
  },
  {
    path: "/stockanalysis",
    name: "Stock",
    beforeEnter: authGuard,
    component: () => import(/* webpackChunkName: "stockanalysis" */ "@/views/Stock.vue"),
    meta: {
      authorizationKey: "InvestorRelationship",
      middleware: [authority],
    },
  },
  {
    path: "/statistics&analysis/attendanceanalysis",
    name: "AttendanceAnalysis",
    beforeEnter: authGuard,
    //component: AttendanceAnalysis,
    component: () =>
      import(/* webpackChunkName: "attendanceanalysis" */ "@/components/statistics/AttendanceAnalysis.vue"),
    meta: {
      authorizationKey: "ViewMeetingStatistics",
      middleware: [authority],
    },
  },
  {
    path: "/statistics&analysis/timeanalysis",
    name: "TimeAllocation",
    beforeEnter: authGuard,
    //component: TimeAllocation,
    component: () =>
      import(/* webpackChunkName: "timeallocation" */ "@/components/statistics/TimeAllocation.vue"),
    meta: {
      authorizationKey: "ViewMeetingStatistics",
      middleware: [authority],
    },
  },
  {
    path: "/statistics&analysis/topic-feedback",
    name: "TopicFeedback",
    beforeEnter: authGuard,
    //component: TimeAllocation,
    component: () =>
      import(/* webpackChunkName: "timeallocation" */ "@/components/statistics/TopicFeedbackAnalysis.vue"),
    meta: {
      authorizationKey: "ViewMeetingStatistics",
      middleware: [authority],
    },
  },
  {
    path: "/task",
    name: "Task",
    beforeEnter: authGuard,
    //component: Task,
    component: () =>
      import(/* webpackChunkName: "tasks" */ "@/views/Task.vue"),
    meta: {
      authorizationKey: "ViewTask",
      middleware: [authority],
    },
  },
  {
    path: "/CVAnalytics",
    name: "CVAnalytics",
    meta: {
      authorizationKey: "CVAnalytics",
      middleware: [authority],
      hideMenu: true
    },
  },
  {
    path: "/BusinessPerformance",
    name: "BusinessPerformance",
    meta: {
      authorizationKey: "ViewBusinessPerformance",
      middleware: [authority],
    },
    component: () =>
      import(/* webpackChunkName: "businessperformance" */ "@/components/business/BusinessSettings.vue")
  },
  {
    path: "/BusinessManagement",
    name: "BusinessManagement",
    meta: {
      authorizationKey: "BusinessManagement",
      middleware: [authority],
    },
    component: () =>
      import(/* webpackChunkName: "tasks" */ "@/views/BusinessManagement.vue")
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
});

// Creates a `nextMiddleware()` function which not only
// runs the default `next()` callback but also triggers
// the subsequent Middleware function.
function nextFactory(context, middleware, index) {
  const subsequentMiddleware = middleware[index];
  // If no subsequent Middleware exists,
  // the default `next()` callback is returned.
  if (!subsequentMiddleware) return context.next;

  return (...parameters) => {
    // Run the default Vue Router `next()` callback first.
    context.next(...parameters);
    // Then run the subsequent Middleware with a new
    // `nextMiddleware()` callback.
    const nextMiddleware = nextFactory(context, middleware, index + 1);
    subsequentMiddleware({ ...context });
  };
}

router.beforeResolve(async (to, from, next) => {
  const auth = getInstance();
  if (from.path === "/forbidden") {
    if (store.state.switchTenantId) {
      sessionStorage.setItem("tenantId", store.state.switchTenantId || "");
      localStorage.setItem("tenantId", store.state.switchTenantId || "");
    }
  }
  next();
});

router.afterEach(async (to, from) => {
  const auth = getInstance();
  if (from.path === "/forbidden" || from.path !== "/") {
    if (store.state.switchTenantId) {
      sessionStorage.setItem("tenantId", store.state.switchTenantId || "");
      localStorage.setItem("tenantId", store.state.switchTenantId || "");
    }
  }
});

router.beforeEach(async (to, from, next) => {
  const { tenantId } = to.params;
  const { tenant } = to.query;
  const localTenant = sessionStorage.getItem("tenantId");
  if ((tenantId || tenant) && !localTenant) {
    sessionStorage.setItem("tenantId", tenantId || tenant);
    localStorage.setItem("tenantId", tenantId || tenant);
  }
  if (to.meta.middleware) {
    const middleware = Array.isArray(to.meta.middleware)
      ? to.meta.middleware
      : [to.meta.middleware];

    const context = {
      from,
      next,
      router,
      to,
      store,
    };
    // When multiple Middleware used
    // const nextMiddleware = nextFactory(context, middleware, 1);
    // return middleware[0]({ ...context, next: nextMiddleware });

    return middleware[0]({
      ...context,
    });
  } else next();
});

export default router;
